import React from 'react';
import { useSelector } from 'react-redux';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CircularProgress from 'material-ui/Progress/CircularProgress';
import Session from '../calendar/components/Session';
import EmptyState from '../common/EmptyState';
import InstructionVisibilityContext from './InstructionVisibilityContext';
import FullScreenHeader from './FullScreenHeader';
import useFullScreenWorkout from './useFullScreenWorkout';
import useThemeToggle from './useThemeToggle';

const FullScreenWorkoutView = ({ match }) => {
    const { session, isLoading, hasError } = useFullScreenWorkout(
        match.params.programWorkoutId
    );
    const calendarInstructionsEnabled = useSelector(
        state => state.calendar.uiTree.calendarInstructionsEnabled
    );
    const [theme, toggleTheme] = useThemeToggle();

    return (
        <InstructionVisibilityContext.Provider
            value={{
                showInstructions: !isLoading && calendarInstructionsEnabled,
                isFullScreen: true
            }}
        >
            <div className="fullscreen-workout" data-theme={theme}>
                <FullScreenHeader
                    session={session}
                    theme={theme}
                    onToggleTheme={toggleTheme}
                />
                <div
                    className={
                        isLoading
                            ? 'fullscreen-workout-content loading'
                            : hasError
                                ? 'fullscreen-workout-content empty'
                                : 'fullscreen-workout-content'
                    }
                >
                    {isLoading ? (
                        <CircularProgress
                            height={48}
                            width={48}
                            style={{ color: 'var(--fs-text-primary)' }}
                        />
                    ) : hasError ? (
                        <EmptyState
                            icon={
                                <ErrorOutlineIcon
                                    style={{
                                        fontSize: 48,
                                        marginBottom: 8,
                                        color: 'var(--fs-text-primary)'
                                    }}
                                />
                            }
                            title="Something went wrong"
                            text="We couldn't load this workout."
                        />
                    ) : (
                        <Session session={session} isPreview={true} />
                    )}
                </div>
            </div>
        </InstructionVisibilityContext.Provider>
    );
};

export default FullScreenWorkoutView;



// WEBPACK FOOTER //
// ./src/view/fullScreenWorkout/FullScreenWorkoutView.jsx